import AddIcon from '@mui/icons-material/Add';
import { Button, Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectUserList, selectUserRole } from '../../redux/reducers/organizationReducer';
import AddUserModal from './AddUserModal';
import EditUserModal from './EditUserModal';
import { UserRoles } from '../../redux/reducers/authenticationReducer';

export default function UserList() {
  const { t } = useTranslation();
  const userList = useSelector(selectUserList);
  const role = useSelector(selectUserRole);
  const [openAddUser, setOpenAddUser] = useState(false);
  const [openEditUser, setOpenEditUser] = useState(undefined);

  const columns = [
    {
      field: 'userFirstName',
      headerName: t('organization.userFirstName'),
      flex: 1,
      editable: false,
    },
    {
      field: 'userLastName',
      headerName: t('organization.userLastName'),
      flex: 1,
      editable: false,
    },
    {
      field: 'userEmail',
      headerName: t('organization.userEmail'),
      flex: 1,
      editable: false,
    },
    {
      field: 'userPhone',
      headerName: t('organization.userPhone'),
      flex: 1,
      editable: false,
    },
    {
      field: 'userRole',
      headerName: t('organization.userRole'),
      editable: false,
      flex: 1,
    },
  ];

  const rows = userList.map((user) => ({
    id: user.id,
    userFirstName: user.firstName,
    userLastName: user.lastName,
    userEmail: user.email,
    userPhone: user.phone,
    userRole: t(`person.roles.${user.role}`),
  }));

  const toggleAddUser = () => {
    setOpenAddUser(!openAddUser);
  };

  const toggleEditUser = (event) => {
    setOpenEditUser(event?.id ?? undefined);
  };

  return (
    <>
      {openAddUser && (
        <AddUserModal
          handleClose={toggleAddUser}
        />
      )}
      {openEditUser && (
        <EditUserModal
          handleClose={toggleEditUser}
          contactId={openEditUser}
        />
      )}
      <Stack direction="row" justifyContent="space-between">
        <Typography Id='users-header' variant="soaTitle">{t('person.selector.users')}</Typography>
        {role === UserRoles.ADMIN && (
          <Button id='add-user' variant="contained" endIcon={<AddIcon />} onClick={() => toggleAddUser()}>
            {t('person.user.add')}
          </Button>
        )}
      </Stack>
      <Stack direction="column" spacing={2}>
        <Typography
          variant="body1"
          sx={{
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
          }}
        >
          {t('organization.userDesc')}
        </Typography>
        <DataGrid
          autoHeight
          disableRowSelectionOnClick
          columns={columns}
          rows={rows}
          onRowClick={(event) => toggleEditUser(event)}
        />
      </Stack>
    </>
  );
}
